export default "__VITE_ASSET__CQNKoI2A__"